"use client";
import React from "react";

interface FormFieldProps {
    label: string;
    name: string;
    type: string;
    value: string;
    placeholder: string;
    required?: boolean;
    additionalInfo?: string;
    rows?: number;
    onChange: (value: string) => void;
    error?: string;
}

const FormField: React.FC<FormFieldProps> = ({
    label,
    name,
    type,
    value,
    placeholder,
    required,
    additionalInfo,
    rows,
    onChange,
    error,
}) => {
    return (
        <div className="w-full md:w-3/4 mx-auto">
            <label htmlFor={name} className="block text-sm font-medium text-tblack">
                {required && <span className="text-rose">*</span>}
                {label} {additionalInfo && <i className="text-gray-500">{additionalInfo}</i>}
            </label>
            {type === "textarea" ? (
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`mt-2 block w-full px-4 py-3 border rounded-md shadow-sm sm:text-sm ${error ? "border-red-500" : "border-gray-300"
                        }`}
                    placeholder={placeholder}
                    rows={rows}
                />
            ) : (
                <input
                    type={type}
                    id={name}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`mt-2 block w-full px-4 py-3 border rounded-md shadow-sm sm:text-sm ${error ? "border-red-500" : "border-gray-300"
                        }`}
                    placeholder={placeholder}
                />
            )}
            {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
        </div>
    );
};

export default FormField;
